import { Settings } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { formatTime } from '@/utils/formatters';
import { wizardBlockCardClassName } from '../wizardBlockChrome';

export interface TournamentConfigSummaryCardProps {
  signupDeadlineDate: Date | null;
  matchDuration: number;
  minSchedulesRequired: number | null;
  /** When false, the "Mín. horarios" segment is omitted (e.g. Americano format). Defaults to true. */
  showMinSchedules?: boolean;
  countsForCategoryRanking?: boolean;
  categoryRankingTargetLabel?: string;
}

export function TournamentConfigSummaryCard({
  signupDeadlineDate,
  matchDuration,
  minSchedulesRequired,
  showMinSchedules = true,
  countsForCategoryRanking = true,
  categoryRankingTargetLabel,
}: TournamentConfigSummaryCardProps) {
  if (!signupDeadlineDate) return null;

  const minSchedules = minSchedulesRequired ?? 1;

  return (
    <Card className={wizardBlockCardClassName}>
      <CardContent className="p-4">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-100">
            <Settings className="h-5 w-5 text-blue-600" />
          </div>
          <div>
            <p className="font-medium text-blue-900">Configuración completa</p>
            <p className="text-sm text-blue-800/90">
              Cierre:{' '}
              {signupDeadlineDate.toLocaleDateString('es-AR', {
                weekday: 'long',
                day: 'numeric',
                month: 'long',
                year: 'numeric',
              })}{' '}
              a las {formatTime(signupDeadlineDate)}{' '}
              · Duración: {matchDuration} min
              {showMinSchedules && ` · Mín. horarios: ${minSchedules}`}
              {` · Suma al ranking: ${
                countsForCategoryRanking
                  ? (categoryRankingTargetLabel ?? 'Sí')
                  : 'No'
              }`}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
